import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "./CSS/Navbar.css";

function NavBar() {
  return (
    <div className="navCent">
      <Navbar collapseOnSelect expand="lg" sticky="top" className="NavCol">
        <Container style={{ justifyContent: "space-between" }}>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="navCent">
              <Nav.Link
                href="/"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
              >
                Home
              </Nav.Link>
              <Nav.Link
                href="/#aboutus"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
              >
                About Us
              </Nav.Link>
              <Nav.Link
                href="/features"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
              >
                Features
              </Nav.Link>

              <NavDropdown
                title={
                  <span style={{ color: "red", fontSize: 18, margin: "0 8px" }}>
                    Courses
                  </span>
                }
                id="courses-dropdown"
                className="same-width-dropdown"
              >
                <NavDropdown.Item href="/courses">
                  Research and Technical-Research
                </NavDropdown.Item>

                <NavDropdown.Item href="/ResearchSummary">
                  Research Summary
                </NavDropdown.Item>

                <NavDropdown
                  title={<span className="customMargin">Summer School</span>}
                  id="summer-dropdown"
                  className="same-width-dropdown nested-dropdown"
                >
                  <NavDropdown.Item href="/rmds">Home</NavDropdown.Item>
                  <NavDropdown.Item href="/rmds/reg">
                    Registration
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/rmds/schedule">
                    Schedule
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/rmds/speakers">
                    Speakers
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/rmds/resource">
                    Resources
                  </NavDropdown.Item>
                </NavDropdown>
              </NavDropdown>

              {/* In future use */}

              {/* <Nav.Link href="/conferences"  style={{color:'red',fontSize:18,margin:"0 8px"}}>Conferences</Nav.Link>
            <Nav.Link href="/schools"  style={{color:'red',fontSize:18,margin:"0 8px"}}>Schools</Nav.Link>       
            <Nav.Link href="/internships"  style={{color:'red',fontSize:18,margin:"0 8px"}}>Internships</Nav.Link>  */}
              {/* <Nav.Link href="/workshop"  style={{color:'red',fontSize:18,margin:"0 8px"}}>Workshop</Nav.Link> */}
              <NavDropdown
                title={
                  <span style={{ color: "red", fontSize: 18, margin: "0 8px" }}>
                    Conferences
                  </span>
                }
                id="conferences-dropdown"
                className="same-width-dropdown"
              >
                <NavDropdown.Item
                  href="https://dosci-conf.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  DOSCI Conference
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="https://icccnet.co.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ICCCNET
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="https://comsia.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  COMSIA
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="https://icctrda.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ICCTRDA
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="https://dasgri.co.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  DASGRI
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="https://iciccsconference.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ICICCS Conference
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="https://sngc-conf.co.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SNGC Conference
                </NavDropdown.Item>

                <NavDropdown.Item
                  href="https://icaisid-conf.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ICAISD
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                href="https://conferenceseries.adroidjournals.com/index.php/ACSET"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
                target="blank"
              >
                Conference Proceedings
              </Nav.Link>

              <Nav.Link
                href="https://books.adroidjournals.com/index.php/aisem/index"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
                target="blank"
              >
                Book Series
              </Nav.Link>

              <Nav.Link
                href="https://www.adroidcms.com"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
                target="blank"
              >
                Adroid CMS
              </Nav.Link>
              <Nav.Link
                href="/mentors"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
              >
                Mentors
              </Nav.Link>
              <Nav.Link
                href="/journals"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
              >
                Journals
              </Nav.Link>
              <Nav.Link
                href="/people"
                style={{ color: "red", fontSize: 18, margin: "0 8px" }}
              >
                People
              </Nav.Link>
              

              {/* <NavDropdown  title={<span style={{color:"red",fontSize:18,margin:"0 8px"}}>ICHBA 2024</span>} id="collasible-nav-dropdown" >
              <NavDropdown.Item href="/ichba">Home</NavDropdown.Item>
              <NavDropdown.Item href="/ichba/callforpapers">Call for Papers</NavDropdown.Item>
              <NavDropdown.Item href="/ichba/registration">Registration</NavDropdown.Item>   
              <NavDropdown.Item href="/ichba/papersubmission">Paper Submission</NavDropdown.Item>   
              <NavDropdown.Item href="/ichba/downloads">Downloads</NavDropdown.Item>                           
            </NavDropdown> */}
            </Nav>
            {/* <Link to='https://play.google.com/store/apps/details?id=com.adroid.adroidconnectz&pli=1'><img src={playstore} style={{width:'125px'}}/></Link>*/}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
export default NavBar;
